import { Component, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';

@Component({
    selector: 'modal-cor-vacina',
    templateUrl: 'modal-cor-vacina-component.html',
    styleUrls: ['modal-cor-vacina-component.scss']
})

export class ModalCorVacinaComponent {
  
    tipos = [{
        color: '#34CD62',
        border: '1px solid #34CD62',
        nome: 'FIOCRUZ'
    }, {
        color: '#026C02',
        border: '1px solid #026C02',
        nome: 'BUTANTAN'
    }, {
        color: '#99B3FE',
        border: '1px solid #99B3FE',
        nome: 'PFIZER'
    }, {
        color: '#FAB600',
        border: '1px solid #FAB600',
        nome: 'JANSSEN'
    }, {
        color: '#FC7998',
        border: '1px solid #FC7998',
        nome: 'ASTRAZENECA'
    }];

    constructor(
                private modalController: ModalController) {
    }

    ngOnInit() {

    }
  
    voltar() {
        this.modalController.dismiss();
        (window.document.querySelector('ion-router-outlet') as HTMLElement).classList.remove('cameraViewr');
    }

}
